<ion-badge class="badge" [color]="color">
  {{ label }}
</ion-badge>
